import {
  Button,
  Collapse,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  Steps,
} from "antd";
import Text from "antd/lib/typography/Text";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
import Close from "../../assets/icons/close.png";
import {
  getBoolVal,
  hasAccess,
  isSuperAdmin,
  objectToFormData,
} from "../../utils";
import AdvReport from "./../Advances/AdvReport";
import PageHeader from "./../PageHeader";
import LinkTripsToReport from "./LinkTripsToReport";
import TripTypeTable from "./TripTypeTable";

import { DownOutlined, MessageOutlined, UserOutlined } from "@ant-design/icons";
import { PDFDownloadLink, usePDF } from "@react-pdf/renderer";
import NoCommentsComponent from "../Common/NoComentsComponent";
import NodataComponent from "../Common/NodataComponent";
import TripsOne from "../Common/PDF/PDFTripsTemplates/TripsOne";
import {
  RecallTrip,
  recallTrip,
  trip_details_pdf,
  trips_close,
  trips_show,
  tripsAddComments,
  tripsApprove,
  TripsApprove,
  TripsAddComments,
  TripsClose,
  tripsComments,
  tripsHistory,
  tripsReject,
  TripsReject,
  TripsShow,
  UserReportLinkTrip,
  userReportLinkTripReset,
  userTripsSubmit,
  UserTripsSubmit,
} from "./../../actions/trips/trips";
import "./trips.css";
import Loader from "../Loader";
import moment from "moment";

const { Panel } = Collapse;
const { Step } = Steps;
const { TextArea } = Input;

const formatCommentTimestamp = (createdAt) => {
  if (!createdAt) {
    return "-";
  }

  const parsedDate = moment(
    createdAt,
    [
      "DD-MM-YYYY,HH:mm:ss",
      "DD-MM-YYYY, HH:mm:ss",
      "DD-MM-YYYY HH:mm:ss",
      "YYYY-MM-DD HH:mm:ss",
      moment.ISO_8601,
    ],
    true,
  );

  if (parsedDate.isValid()) {
    return parsedDate.format("DD-MM-YYYY, HH:mm:ss");
  }

  const fallbackDate = moment(createdAt);
  return fallbackDate.isValid()
    ? fallbackDate.format("DD-MM-YYYY, HH:mm:ss")
    : createdAt;
};

const TripDetail = () => {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = params;
  const inputComment = React.useRef(null);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setModalType] = React.useState("");
  const [tripsCommentsData, setTripsCommentsData] = React.useState([]);
  const [tripHistory, setTripHistory] = React.useState([]);
  const [input, setInput] = React.useState("");
  const [reasonValue, setReasonValue] = React.useState("");
  const [isURL, setIsURL] = React.useState("");

  const tripsResponse = useSelector((state) => state.trips.trips || {});
  // const trip_detail_pdf = useSelector((state) => state.trips.tripDetailPDF?.data?.response?.trip_url || "");
  const {
    location: { state: { tripData = {} } = {} },
  } = history;
  const tripsCommentsResponse = useSelector(
    (state) => state.trips.tripsComments || {},
  );
  const tripsCommentsAddResponse = useSelector(
    (state) => state.trips.tripsCommentsAdd || {},
  );
  const tripsHistoryResponse = useSelector(
    (state) => state.trips.tripsHistory || {},
  );
  const tripsApproveResponse = useSelector(
    (state) => state.trips.tripsApprove || {},
  );
  const tripsRejectResponse = useSelector(
    (state) => state.trips.tripsReject || {},
  );
  const userTripsSubmitResponse = useSelector(
    (state) => state.trips.userTripsSubmit || {},
  );
  const userReportLinkTripResponse = useSelector(
    (state) => state.trips.userReportLinkTrips || {},
  );
  const tripsClose = useSelector((state) => state.trips.tripsClose || {});
  // const tripPDF = useSelector((state) => state.trips.tripDetailPDF?.data?.response || {});
  const tripsData = useSelector(
    (state) => state?.trips?.tripsShow?.data?.response?.trips?.[0] || {},
  );
  const tripsDataLoading = useSelector(
    (state) => state?.trips?.tripsShow?.loading,
  );
  const tripRecallResponse = useSelector(
    (state) => state?.trips?.tripsRecall || {},
  );

  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );

  const [instance, updateInstance] = usePDF({
    document: (
      <TripsOne
        data={tripsData}
        tripsHistory={tripsHistoryResponse?.data?.response?.history}
        CommentsData={tripsCommentsResponse?.data?.response?.comments}
      />
    ),
  });

  React.useEffect(() => {
    updateInstance(
      <TripsOne
        data={tripsData}
        tripsHistory={tripsHistoryResponse?.data?.response?.history}
        CommentsData={tripsCommentsResponse?.data?.response?.comments}
      />,
    );
  }, [tripsData, tripsHistoryResponse, tripsCommentsResponse]);

  React.useEffect(() => {
    if (id) {
      dispatch(
        trips_show({
          id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
      dispatch(
        trip_details_pdf({
          id: id,
        }),
      );
      dispatch(
        tripsComments(
          { trip_id: id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch(
        tripsHistory(
          { trip_id: id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
    }

    return () => {
      dispatch(userReportLinkTripReset());
      dispatch({
        type: TripsAddComments.RESET,
      });
      dispatch({
        type: TripsShow.RESET,
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      userReportLinkTripResponse;
    if (status) {
      handleCancel();
      dispatch({
        type: UserReportLinkTrip.RESET,
      });
      dispatch(
        trips_show({
          id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportLinkTripResponse]);
  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      tripRecallResponse;
    if (status) {
      handleCancel();
      dispatch({
        type: RecallTrip.RESET,
      });
      dispatch(
        trips_show({
          id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripRecallResponse]);
  React.useEffect(() => {
    const {
      data: { response: { trips: tripsList = [] } = {}, status = false } = {},
    } = tripsResponse;
    if (status) {
      setTripsCommentsData(tripsList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripsResponse]);

  React.useEffect(() => {
    const { data: { response: { history = [] } = {}, status = false } = {} } =
      tripsHistoryResponse;
    if (status) {
      setTripHistory(history);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripsHistoryResponse]);

  React.useEffect(() => {
    const { data: { response: { comments = [] } = {}, status = false } = {} } =
      tripsCommentsResponse;
    if (status) {
      setTripsCommentsData(comments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripsCommentsResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      tripsCommentsAddResponse;
    if (status && (tripsData.id || id)) {
      dispatch(
        tripsComments(
          { trip_id: tripsData.id || id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch({
        type: TripsAddComments.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripsCommentsAddResponse, tripsData.id, id]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      tripsApproveResponse;
    if (status) {
      dispatch(
        trips_show({
          id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
      dispatch({
        type: TripsApprove.RESET,
      });
    } else {
      if (res_message) {
        dispatch({
          type: TripsApprove.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripsApproveResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      tripsRejectResponse;
    if (status) {
      dispatch(
        trips_show({
          id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
      setIsModalVisible(false);
      if (modalType === "delete") {
        history.push("/trips");
      }
      dispatch({
        type: TripsReject.RESET,
      });
    } else {
      if (res_message) {
        dispatch({
          type: TripsApprove.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripsRejectResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      tripsClose;
    if (status) {
      dispatch({
        type: TripsClose.RESET,
      });
      history.push("/trips");
    } else {
      if (res_message && status === false) {
        dispatch({
          type: TripsClose.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripsClose]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      userTripsSubmitResponse;
    if (status) {
      history.push("/trips/");
      dispatch({
        type: UserTripsSubmit.RESET,
      });
      // dispatch(trips({ trip_id: tripsData.id }));
    } else {
      if (res_message) {
        dispatch({
          type: UserTripsSubmit.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userTripsSubmitResponse]);

  const handleAddComment = () => {
    if (input?.trim() && tripsData.id) {
      dispatch(
        tripsAddComments(
          objectToFormData({
            body: input,
            trip_id: tripsData.id,
          }),
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      setInput("");
    }
  };

  const renderUnrepOption = () => {
    return (
      <>
        <LinkTripsToReport trip_id={tripData.id} />
      </>
    );
  };

  const renderModalData = (type) => {
    switch (type) {
      case "delete":
        return renderDeleteOption();
      case "reject":
        return renderRejectOption();
      case "addUnrepExp":
        return renderUnrepOption();
      default:
        return "";
    }
  };

  const renderModalTitle = (type) => {
    switch (type) {
      case "delete":
        return "Delete Trip";
      case "reject":
        return "Reject Trip";
      case "addUnrepExp":
        return "Add Trip to Report";
      default:
        return "";
    }
  };

  const renderModalClass = (type) => {
    switch (type) {
      case "delete":
        return "center-aligned-modal";
      case "reject":
        return "center-aligned-modal";
      case "addUnrepExp":
        return "right-alinged-modal";
      default:
        return "";
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const renderRejectOption = () => {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(
            tripsReject(
              objectToFormData({ id: tripsData.id, reason: reasonValue }),
            ),
          );
        }}
      >
        <Text>Please specify an appropriate reason for rejection.</Text>
        <br />
        <TextArea
          rows={4}
          placeholder="Enter Reason"
          className="reasonTextArea"
          onChange={(e) => setReasonValue(e.target.value)}
          required={true}
        />
        <br />
        <Button
          key="1"
          className="formButton mt1"
          disabled={!reasonValue || tripsRejectResponse?.loading}
          htmlType="submit"
        >
          Confirm
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          htmlType="button"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </form>
    );
  };

  const renderDeleteOption = () => {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(
            tripsReject(objectToFormData({ id: tripsData.id }), {
              isDelete: true,
            }),
          );
        }}
      >
        <Text>Are you sure you want to delete.</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          disabled={tripsRejectResponse?.loading}
          htmlType="submit"
        >
          Confirm
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          htmlType="button"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </form>
    );
  };
  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        disabled={!isURL}
        title={!isURL ? "PDF is not there for this trip" : ""}
        onClick={() => {
          window.open(isURL, "_blank");
        }}
      >
        Download PDF
      </Menu.Item>
      {/* <Menu.Item key="2">Download Receipts</Menu.Item> */}

      {/* <Menu.Item key="4">Print</Menu.Item>  */}
    </Menu>
  );

  const emp_id = sessionStorage.getItem("employee_id");

  React.useEffect(() => {
    if (!instance.loading && instance.url) {
      setIsURL(instance.url);
    }
  }, [instance]);

  return (
    <>
      {tripsDataLoading ? <Loader /> : null}

      <Modal
        title={renderModalTitle(modalType)}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={renderModalClass(modalType)}
      >
        {renderModalData(modalType)}
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Trips`}
          navigation={{
            Home:
              hasAccess("dashboard", "read") || hasAccess("dashboard", "write")
                ? "/dashboard"
                : "",
            Trips: "/trips/",
          }}
        />
      </div>
      {(Array.isArray(tripData?.trip_approvers_data) &&
        tripData?.trip_approvers_data?.includes(emp_id)) ||
      is_admin ||
      tripsDataLoading ? (
        <div className="trips-detail detail-card">
          <section className="head">
            <div className="flex-between">
              <div className="v-center">
                <h3>{tripsData?.title}</h3>
                <span
                  className={`status status_${
                    is_admin
                      ? tripsData?.current_trip_status
                      : tripsData?.status
                  }`}
                >
                  {is_admin
                    ? tripsData?.current_trip_status?.replace(/_/g, " ")
                    : tripsData?.status?.replace(/_/g, " ")}
                </span>
              </div>
              <div className="d-flex action-btns">
                {is_admin ? (
                  <>
                    {hasAccess("trips", "write") &&
                    (!tripsData?.action_restrict || isSuperAdmin()) &&
                    tripsData?.current_trip_status === "pending_approval" ? (
                      <>
                        <button
                          className="approve"
                          disabled={tripsApproveResponse?.loading}
                          onClick={() => {
                            dispatch(
                              tripsApprove(
                                objectToFormData({
                                  id: tripsData.id,
                                  trip_id: tripsData.id,
                                }),
                              ),
                            );
                          }}
                        >
                          Approve
                        </button>
                        <button
                          className="reject"
                          // disabled={tripsRejectResponse?.loading}
                          onClick={() => {
                            setIsModalVisible(true);
                            setModalType("reject");
                          }}
                        >
                          Reject
                        </button>
                      </>
                    ) : null}{" "}
                  </>
                ) : (
                  <>
                    {hasAccess("trips", "write") &&
                    tripsData.status === "unsubmitted" ? (
                      <>
                        <button
                          className="approve"
                          disabled={userTripsSubmitResponse?.loading}
                          onClick={() =>
                            dispatch(
                              userTripsSubmit(
                                objectToFormData({ trip_id: tripsData.id }),
                                {
                                  is_admin: getBoolVal(
                                    sessionStorage.getItem("is_admin"),
                                  ),
                                },
                              ),
                            )
                          }
                        >
                          Submit
                        </button>
                        <button
                          className="reject"
                          onClick={() =>
                            history.push({
                              pathname: `/add-trip/`,
                              state: { tripData: tripsData },
                            })
                          }
                        >
                          Edit
                        </button>
                        {!is_admin && (
                          <button
                            onClick={() => {
                              setIsModalVisible(true);
                              setModalType("delete");
                            }}
                            // onClick={() => handleAddExp()}
                            className="delete"
                          >
                            Delete
                          </button>
                        )}
                      </>
                    ) : null}
                    {hasAccess("trips", "write") &&
                    tripsData?.recallable &&
                    tripsData?.status === "pending_approval" ? (
                      <>
                        <button
                          className="reject"
                          disabled={tripRecallResponse?.loading}
                          onClick={() =>
                            dispatch(recallTrip({ id: params.id }))
                          }
                        >
                          Recall
                        </button>
                      </>
                    ) : null}
                  </>
                )}
                {hasAccess("trips", "write") &&
                !is_admin &&
                tripsData?.status !== "cancelled" &&
                tripsData?.status !== "added_to_report" &&
                tripsData?.status !== "closed" ? (
                  <>
                    <button
                      className="reject"
                      disabled={tripRecallResponse?.loading}
                      onClick={() =>
                        dispatch(recallTrip({ id: params.id, isCancel: true }))
                      }
                    >
                      Cancel
                    </button>
                  </>
                ) : null}
                {hasAccess("trips", "write") &&
                  !is_admin &&
                  tripsData.status === "approved" && (
                    <>
                      <Button
                        onClick={() => {
                          setIsModalVisible(true);
                          setModalType("addUnrepExp");
                        }}
                        // onClick={() => handleAddExp()}
                        className="floatRight ml1 primaryButton"
                      >
                        {tripsData?.report?.length > 0 ? "Change" : "Add to"}{" "}
                        Report
                      </Button>
                      <button
                        className="approve"
                        disabled={tripsClose?.loading}
                        onClick={() => {
                          dispatch(
                            trips_close({
                              trip_id: tripsData.id,
                            }),
                          );
                        }}
                      >
                        Mark as Close
                      </button>
                    </>
                  )}
                <Dropdown overlay={menu} placement="bottomRight">
                  <button className="more">
                    More&nbsp;
                    <DownOutlined />
                  </button>
                </Dropdown>
                <span
                  className="close cursor"
                  onClick={() =>
                    history.push({
                      pathname: `/trips/`,
                      state: {
                        filter: location.state.status,
                      },
                    })
                  }
                >
                  <img src={Close} width={20} alt={"close"} />
                </span>
              </div>
            </div>
            <div>
              <span className="duration">
                 Submitted on : {
                  tripsData?.submitted_on
                    ? moment(tripsData.submitted_on, "DD-MM-YYYY HH:mm:ss").format(
                        "DD-MM-YYYY, HH:mm:ss"
                      )
                    : ""
                }
              </span>
            </div>
          </section>
          <hr />
          <>
            <section className="trips-info">
              <div className="title-card d-flex">
                <p>
                  <span>
                    Submitted by :<br />
                    {tripsData?.submitted_by}
                  </span>
                    <span className="sm">on {
                    tripsData?.submitted_on
                      ? moment(tripsData.submitted_on, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY, HH:mm:ss")
                      : ""
                  }</span>
                </p>
                <p>
                  <span>
                    Submitted to :<br />
                  </span>
                  <span>
                    {tripsData.submitted_to_email || tripsData.submitted_to}
                  </span>
                </p>
                {tripsData?.status === "pending_approval" && (
                  <p>
                    <span>
                      Pending approval :<br />
                    </span>
                    <span className="dim">
                      {tripsData?.pending_approval_by || tripsData?.email}
                    </span>
                  </p>
                )}
              </div>
              <div className="trips-total title-card">
                <span>
                  <b>Destination</b>:{" "}
                  {
                    tripsData?.fields?.find(
                      (ele) => ele.key === "Destination Country",
                    )?.value
                  }
                </span>
                <span>
                  <b>Business Purpose</b>: {tripsData?.business_purpose}
                </span>
                <span>
                  <b>Trip type</b>: {tripsData?.trip_type}
                </span>
              </div>
            </section>
            {tripsData?.custom_fields?.length > 0 && (
              <div className="trips-info title-card loop">
                {tripsData?.custom_fields?.map((ele) => (
                  <p>
                    <span className="mr1" style={{ display: "inline" }}>
                      {ele.key === "destination_city"
                        ? "Destination City"
                        : ele.key}
                      : :
                    </span>
                    {ele.value}
                  </p>
                ))}
              </div>
            )}
          </>
          <div className="trip-tables ml2 mr2 mt1 mb1">
            <Collapse bordered={false} defaultActiveKey={["1", "32"]}>
              <Panel
                header={
                  <span>Associated Reports {tripsData?.report?.length}</span>
                }
                key="32"
              >
                {tripsData && tripsData.report ? (
                  <AdvReport repData={tripsData.report} from="report" />
                ) : (
                  <NodataComponent />
                )}
              </Panel>
              <Panel header={<span>Trip Itinerary</span>} key="1">
                {tripsData ? (
                  <>
                    <h3 className="mt1">Flight Reservations</h3>
                    <TripTypeTable type="flight" />
                    <h3>Hotel Reservations</h3>
                    <TripTypeTable type="hotel" />
                    <h3>Car Rentals</h3>
                    <TripTypeTable type="car" />
                    <h3>Other Bookings</h3>
                    <TripTypeTable type="others" />
                  </>
                ) : (
                  <NodataComponent />
                )}
              </Panel>
              <Panel
                header={
                  <span>
                    Comments <strong>{tripsCommentsData.length}</strong>
                  </span>
                }
                key="5"
              >
                <div className="addComment mt2 mb1">
                  <Input
                    placeholder="Enter Comment"
                    value={input}
                    onChange={(e) => setInput(e.target.value.trimStart())}
                  />
                  <Button
                    key="1"
                    className="formButton ml1"
                    onClick={() => handleAddComment()}
                  >
                    Send
                  </Button>
                </div>
                {tripsCommentsData.length ? (
                  <>
                    <div className="commentsSection mt2">
                      <Steps
                        direction="vertical"
                        size="small"
                        current={tripsCommentsData.length + 1 || 100}
                      >
                        {tripsCommentsData &&
                          tripsCommentsData.map(
                            ({ body, created_at, user_name, id }) => (
                              <Step
                                key={id}
                                title={body}
                                description={
                                  formatCommentTimestamp(created_at) +
                                  " / " +
                                  user_name
                                }
                                icon={<MessageOutlined />}
                              />
                            ),
                          )}
                      </Steps>
                    </div>
                  </>
                ) : (
                  <NoCommentsComponent />
                )}
              </Panel>
              <Panel
                header={
                  <span>
                    History <strong>{tripHistory.length}</strong>
                  </span>
                }
                key="6"
              >
                <div className="commentsSection mt2">
                  <Steps
                    direction="vertical"
                    size="small"
                    current={tripHistory.length + 1 || 100}
                  >
                    {tripHistory &&
                      tripHistory.map(
                        ({ body, created_at, employee_name, id, curr_status }) => (
                          <Step
                            key={id}
                            title={body}
                            description={
                              formatCommentTimestamp(created_at) +
                              " | " +
                              (employee_name || "-") +
                              " | Action: " +
                              (curr_status || "-")
                            }
                            icon={<UserOutlined />}
                          />
                        ),
                      )}
                  </Steps>
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>
      ) : (
        <div className="trips-detail detail-card mb4">
          {`You don't have permissions to view this trip`}
        </div>
      )}
    </>
  );
};

export default TripDetail;
